import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCookie, hasCookie, setCookie } from "../components/shared/Cookie";
import yaml from "js-yaml";

import { getModuleProgresses, idleShutDown, refreshToken, verifyToken } from "../api";
import { IScreen } from "../components/vs-code/types";
export const AuthInfo = React.createContext({});

export const Auth: IScreen = ({ children }) => {
  const params = useParams();
  const queryParams = new URLSearchParams(window.location.search);

  const [user, setUser] = useState<any>(null);
  const [ridersUser, setRidersUser] = useState<any>(null);
  const [project, setProject] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState("editor");
  const [overrideDesignMode, setOverrideDesignMode] = useState<any>(null);
  const [community, setCommunity] = useState<string>(
    queryParams.get("community") || "riders"
  );
  const [verifyError, setVerifyError] = useState<string | null>(null);
  const [shutDown, setShutDown] = useState<any>(null);
  const [accessTokenKey, setAccessTokenKey] = useState<string>(
    params.token?.slice(-8) || "accessToken"
  );
  const [language, setLanguage] = useState<string | undefined>();
  const [userCodeFilePath, setUserCodeFilePath] = useState<string>("");

  const [projectType, setProjectType] = useState<string>("robotics");

  const [yamlData, setYamlData] = useState<any>(null);
  const [yamlInit, setYamlInit] = useState<boolean>(false);

  const [config, setConfig] = useState<any>({});


  const [progressedChapters, setProggressedChapters] = useState<Array<number>>(
    []
  );

  const [contentId, setContentId] = useState<string | null>(null);

  const [contentEditMode, setContentEditMode] = useState<boolean>(false);
  const [haveOverrides, setHaveOverrides] = useState<boolean>(false);

  const [modifiedNotification, setModifiedNotification] = useState<
    string | undefined
  >();

  const [modifiedFiles, setModifiedFiles] = useState<string[]>([]);

  const [isBranchOwner, setIsBranchOwner] = useState<boolean>(true);

  const getToken = () => {
    return getCookie(accessTokenKey);
  };

  const getProject = () => {
    return project;
  };



  useEffect(() => {
    if (["cpp", "ino"].includes(language!)) {
      setProjectType("electronics");
      setUserCodeFilePath("usercode/user_code.ino");
      document.getElementsByTagName("html")[0].classList.remove("dark");
    }

    if (language === "python") {
      setUserCodeFilePath("usercode/user_code.py");
    }
  }, [language]);

  useEffect(() => {
    const apiToken = getCookie(accessTokenKey) || params.token!;

    const verifyTokenWithRetry = async () => {
      try {
        return await verifyToken(apiToken); // 1. deneme
      } catch (e1) {
        try {
          await new Promise((res) => setTimeout(res, 1000)); // 2. deneme (1s sonra)
          return await verifyToken(apiToken);
        } catch (e2) {
          try {
            await new Promise((res) => setTimeout(res, 2000)); // 3. deneme (2s sonra)
            return await verifyToken(apiToken);
          } catch (e3) {
            // 3. deneme de başarısız
            throw e3;
          }
        }
      }
    };

    verifyTokenWithRetry()
      .then((data) => {
        const {
          status,
          user,
          accessToken,
          git_address,
          git_branch_name,
          is_preview,
          session_id,
          active_sessions,
          project_id,
          project,
          files,
          storage,
          storage_address,
          session_user_name,
          override_design_params,
          ridersUserData
        } = data;

        if (session_user_name !== user.username) {
          setIsBranchOwner(false);
        }

        if (status === "verified") {
          setLanguage(project.language ? project.language : "python");
          setOverrideDesignMode(override_design_params?.user_role ?? null);
          setCookie(
            accessTokenKey,
            accessToken,
            new Date().getTime() + 1000 * 60 * 60 * 24
          );
          setUser(user);
          setRidersUser(ridersUserData);
          setConfig(project);
          console.log("project", project);
          setProject({
            ...project,
            blocklyTheme: project.blocklyTheme || "zelos",
            project_id: project_id,
            git_address: git_address,
            git_branch: git_branch_name,
            session_id: session_id || "23",
            activeSessionList: active_sessions || [],
            storage_address: storage_address,
            storage: storage,
            files: files,
            session_user_name: session_user_name,
          });
          setContentId(project_id);
          setMode(is_preview ? "preview" : "editor");

          getModuleProgresses(getCookie(accessTokenKey) as string)
            .then((moduleProgresses) => {
              setProggressedChapters(
                moduleProgresses.titles.map((t: string) => parseFloat(t)).filter((t: number) => t > 0)
              );
            });

          fetch(
            project.new_system
              ? `${process.env.REACT_APP_CDN_URL}/content/internal/${project_id}/layouts.yaml`
              : `${process.env.REACT_APP_CDN_URL}/projects/${project?.name}/layouts.yaml`
          )
            .then((response) => {
              if (!response.ok) throw new Error("Network response was not ok");
              return response.text();
            })
            .then((data) => {
              const jsonData = yaml.load(data) as any;

              setProject((prev: any) => ({
                ...prev,
                dev: jsonData.editorType || prev.dev,
                language: jsonData.language || prev.language,
              }));

              setYamlData(jsonData);
              setYamlInit(true);
            })
            .catch(() => {
              setYamlData({
                namePrefix: "Projeniz:",
                namePrefixEn: "Your Project:",
                name: "Projenizi Oluşturun",
                nameEn: "Create Your Project",
                chapters: [
                  {
                    name: "Proje Ayarlarınızı Yapın",
                    nameEn: "Set Your Project Settings",
                    cells: [
                      {
                        type: "Documentation",
                        relativePath: "htmls/TUR/1.html",
                        relativePathEn: "htmls/ENG/1.html",
                      },
                    ],
                    subchapters: [
                      {
                        name: "Yeni Ekran",
                        nameEn: "New Screen",
                        icon: "code",
                        cells: [
                          {
                            type: "Documentation",
                            relativePath: "htmls/TUR/2.html",
                            relativePathEn: "htmls/ENG/2.html",
                          },
                          {
                            type: "Simulation",
                            sourceCode: "user_code4",
                            module: "Xrider_v3_Production#hotRiderFinal#4",
                          },
                        ],
                      },
                    ],
                  },
                ],
              });
              setYamlInit(true);
            });
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("3 deneme de başarısız oldu:", err);
        setLoading(false); // sadece sonuncusu başarısızsa
        if (err === "invalidToken.activeSessionNotFound") {
          setVerifyError("invalidToken.activeSessionNotFound")
        }
      });
  }, []);


  useEffect(() => {
    console.log("contentId", contentId);
  }, [contentId]);



  useEffect(() => {
    if (shutDown) {
      const coverElement = document.getElementById("cover-screen-expires");

      // Eğer cover elementi DOM'dan kaldırılırsa bu fonksiyon çağrılacak
      const onCoverRemoved = () => {
        const htmlElement = document.documentElement;
        if (htmlElement) {
          htmlElement.remove();
        }
      };

      // MutationObserver ile cover elementinin DOM'dan kaldırılıp kaldırılmadığını takip edin
      const observer = new MutationObserver((mutationsList: any) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            for (const removedNode of mutation.removedNodes) {
              if (removedNode === coverElement) {
                onCoverRemoved();
                observer.disconnect(); // Observer'ı durdurun, çünkü artık gerekli değil
                break;
              }
            }
          }
        }
      });

      // cover elementinin ebeveynini gözlemlemeye başlayın
      observer.observe(coverElement?.parentElement as any, { childList: true });
    }
  }, [user]);

  useEffect(() => {
    if (contentEditMode) {
      setYamlData({
        ...yamlData,
        chapters: [
          {
            name: "Proje Ayarlarınızı Yapın",
            cells: [
              {
                type: "Documentation",
                relativePath: "htmls/ENG/1.html",
              },
            ],
            subchapters: [
              {
                name: "Playground",
                icon: "code",
                cells: [
                  {
                    type: "Simulation",
                    sourceCode: "user_code4",
                    module: "Xrider_v3_Production#hotRiderFinal#4",
                    url: "https://d32lhafmwoak77.cloudfront.net/projects/stembox/layoutEditor/index.html?containerless&language=tr&robot_editor=true&editor_design_mode=DEVELOPER",
                  },
                ],
                nameEn: "Playground",
              },
            ],
            nameEn: "Set Your Project Settings",
          },
          ...yamlData.chapters,
        ],
      } as any);
    }
  }, [contentEditMode]);

  return (
    <AuthInfo.Provider
      value={{
        user,
        ridersUser,
        project,
        mode,
        loading,
        setLoading,
        community,
        shutDown,
        setShutDown,
        accessTokenKey,
        language,
        setLanguage,
        getToken,
        getProject,
        projectType,
        setProjectType,
        userCodeFilePath,
        setUserCodeFilePath,
        yamlData,
        setYamlData,
        yamlInit,
        config,
        contentId,
        setContentId,
        contentEditMode,
        setContentEditMode,
        haveOverrides,
        setHaveOverrides,
        modifiedNotification,
        setModifiedNotification,
        isBranchOwner,
        modifiedFiles,
        setModifiedFiles,
        overrideDesignMode,
        progressedChapters,
        setProggressedChapters
      }}
    >
      {children}
    </AuthInfo.Provider>
  );
};

Auth.context = AuthInfo;
